export default function filterBoolean<T>(array: (T | undefined | false)[]): T[] {
  return array.filter(Boolean) as T[];
}
